import { render, staticRenderFns } from "./ClientUnloadingBaseClassSelect.vue?vue&type=template&id=59a98b91&lang=pug"
import script from "./ClientUnloadingBaseClassSelect.vue?vue&type=script&lang=js"
export * from "./ClientUnloadingBaseClassSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports